import { Component, OnInit, Inject } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { SquareupResponseComponent } from '../../mnt-invoices/squareup-response/squareup-response.component'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  public storeProject: any = {};
  public subTotal = 0;
  public prodData: any = {};
  totalCartProduct = 0;
  public SelectProductData: any = [];
  public totalQty = 0;
  public squareStatus = false;
  public transactionId = 0;
  public squareAmount = 0;
  data: any = {};
  shippingMethodName: string;
  orderId:string;
  public customerInvoiceId: string = "";
  public customerInvoiceMode: string = "";

  constructor(private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private dialog: MatDialog,
    private router: Router,
    private activateroute: ActivatedRoute
    ) { }

  ngOnInit() {
    this.orderId=this.activateroute.snapshot.params["order_id"]?this.activateroute.snapshot.params["order_id"]:'';
    if (localStorage.getItem('customerInvoiceId')) {
      this.customerInvoiceId = localStorage.getItem('customerInvoiceId');
      this.customerInvoiceMode = localStorage.getItem('customerInvoiceMode');
    } else {
      this.customerInvoiceId = this.orderId;
    }
    this.data = this.CommonProjectDataService.getStoreCheckOut();
    if(Object.keys(this.data).length != 0){
      let shipping = this.data.shipping_method;
      this.shippingMethodName = this.data.shipping.find(x => x.key_value === shipping).name.split('(').shift();
      this.storeProject = JSON.parse(localStorage.getItem("storeData"));
      this.totalCartProduct = localStorage.getItem("totalCartProduct") ? parseInt(localStorage.getItem("totalCartProduct")) : 0;
      this.SelectProductData = localStorage.getItem("SelectProductData") ? JSON.parse(localStorage.getItem("SelectProductData")) : [];
      this.subTotal = localStorage.getItem("totalPrice") ? Number(localStorage.getItem("totalPrice")) : 0;
      this.totalQty = localStorage.getItem("totalQty") ? parseInt(localStorage.getItem("totalQty")) : 0;
    }
    else{
      this.router.navigate(["store"]);
    }
    this.clearLocalStorage();
  }

  goToStore() {
    this.clearLocalStorage();
    this.router.navigate(["store"]);
  }
  printInvoice() {
    window.print(); 
  }

  clearLocalStorage() {
    localStorage.removeItem('storeData');
    localStorage.removeItem('SelectProductData');
    localStorage.removeItem('totalPrice');
    localStorage.removeItem('totalQty');
    localStorage.removeItem('totalCartProduct');
    localStorage.removeItem('storePaymentBySquare');
    localStorage.removeItem('storeProcessingOrder');
    localStorage.removeItem('storeProcessingData');
    localStorage.removeItem('storeSquarePayableAmount');
    localStorage.removeItem('customerInvoiceId');
    localStorage.removeItem('customerInvoiceMode');
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/thank-you/thank-you.component.ts